import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import Loader from '.';
export const PageLoader = (props) => (_jsx(Flex, { alignItems: "center", bgColor: "background.500", flexGrow: 1, height: "100%", justifyContent: "center", minHeight: "500px", width: "100%", children: _jsx(Loader, Object.assign({}, props)) }));
